import { checkEmailExist, checkUserExist } from 'aster-foundation/core/astercore/auth/login/redux/actions';
import {
  getCityList as getCityListApi,
  getCountryList as getCountryListApi,
  getNationalityBlobList,
  readEmiratesID,
} from 'aster-foundation/core/astercore/profile/masterAPI/redux/actions';
import { completeProfile, editProfile } from 'aster-foundation/core/astercore/profile/profile/redux/actions';
import Image from 'next/image';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import {
  IC_CHAT_BLUE,
  IC_FEMALE,
  IC_FEMALE_BLUE,
  IC_MALE,
  IC_MALE_BLUE,
  IC_PHONE_GREY,
  IC_QUESTION,
  ProfilePlaceholder,
} from '../../../Common/Assets/images';
import BlankCard from '../../../Common/Component/BlankCard/BlankCard';
import {
  dataLayerEditProfileError,
  dataLayerFamilyMembersEdit,
  dataLayerProfileManagementFailure,
  dataLayerProfileManagementSuccess,
  dataLayerProfileUpdateSuccess,
} from '../../../Common/Component/BookAppointment/BookAppointmentAnalytics';
import DateOfBirth from '../../../Common/Component/DateOfBirth/DateOfBirth';
import ExpiryDate from '../../../Common/Component/EidPassportField/ExpiryDate';
import {
  ButtonBase,
  CheckboxControl,
  DropdownControl,
  InputFieldControl,
  MobileInputFieldControl,
  ProfileImageUpload,
  SquareImageUpload,
} from '../../../Common/Component/Forms';
import SearchDropDown from '../../../Common/Component/Forms/SearchDropDown/SearchDropDown';
import SelectControl from '../../../Common/Component/Forms/Select/Select';
import CustomModal from '../../../Common/Component/Modal/Modal';
import SelectTablets from '../../../Common/Component/SelectTablets/SelectTablets';
import { sendAdjustEvent } from '../../../Common/Utility/Adjust';
import {
  NAME_FORMAT,
  PASSPORT_FORMAT,
  convertDateToBackendServer,
  convertDateToISOStandard,
  errorHandling,
  extractQueryString,
  formatDate,
  formatEmiratesId,
  getCityList,
  getCountryList,
  getCurrentYear,
  isImageSizeValid,
  validateEmail,
  getReferralPageForGA,
  getMyAsterCategory,
} from '../../../Common/Utility/common-utils';
import { ADJUST_EVENT_TOKENS, INVALID_DATE, getPageTypeForAddFamily, getScreenNameForAddFamily } from '../../../Common/Utility/constants';
import { sendEventToSmartLook } from '../../../Common/Utility/smartlook';
import { useAuth } from '../../../Common/AuthService';
import { dataLayerSendEvent } from '../../../Epharmacy/EpharmacyAnalytics';
import { AddNewFamilyMemberStyled } from '../AddNewFamilyMember/AddNewFamilyMemberStyled';
import OtpModal from './OtpModal';
import {
  defaultFormState,
  filterErrorObjectBasedOnType,
  filterFormElementsArrBasedOnType,
  formatEmiratesResponse,
  getAge,
  getReqParams,
  isFutureDate,
  months,
  relationshipData,
  setandShowModalProps,
} from './utils';
import HelpPopUp from '../../../Common/Component/HelpPopUp/HelpPopUp';
import ContactFormSidebar from '../../../Common/Component/Footer/ContactFormSidebar';
import Loader from '../../../Common/Component/Loader/Loader';
import { sendEventData } from '../../Auth/Analytics';
import { ERROR_TYPE, EVENT_NAMES, MY_ASTER_CATEGORY, PAGE_TYPE, SCREEN_NAME } from '../../../Common/Constants/analytics';
import { dataLayerAddFamilyMemberError, dataLayerAddFamilyMemberSuccess } from '@common/Utility/analytics-utils';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { getDataFromCookie } from 'aster-foundation/core/common/utils/cookieHelper';
import useModifiedPath from '@common/Hooks/useModifiedPath';

const AutoScrollForm = ({
  title,
  label,
  userData,
  setThankYouScreen,
  setErrorModal,
  type,
  setSuccessModal,
  setEidMessage,
  setIsLoggedInUser,
  sidebarSubmitClicked,
  eventText,
  onSuccess,
  isFromErxOrInstantGp,
  docName,
  setLoadingEdit,
  setDisablePrimaryButtonFromSidebar,
}) => {
  const dispatch = useDispatch();
  const router = useRouter();
  const generateURL = useNavigationURL();
  const getModifiedPath = useModifiedPath();

  const doctorName = router?.query?.doctorname;
  const docID = router?.query?.docID;
  const isEdit = type === 'edit';
  const isAdd = type === 'add';
  const isSidebar = type === 'addSidebar';
  const isCompleteProfile = type === 'completeProfile';
  const isCompleteProfileSecondary = type === 'completeProfileSecondary';
  const isCompleteProfileOther = type === 'completeProfileOther';
  const isNotCompleteProfileScreen = !isCompleteProfile && !isCompleteProfileSecondary && !isCompleteProfileOther;

  const { authCtx } = useAuth();
  const userLogin = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource);
  const loggedInUserID = useSelector((state) => state?.astercore?.checkUserExist?.data?.entry[0]?.resource?.id);
  const countryListSelector = useSelector((state) => state?.astercore?.getCountryListApi?.data?.data);
  const mobileWithCode = userLogin?.telecom?.find((item) => item.system === 'phone')?.value;
  const referralPageForGa = router.asPath ? getReferralPageForGA(router.asPath) : 'Aster Core Login ';

  const [emailExistError, setEmailExistError] = useState(false);
  const [modal, setModal] = useState(false);
  const [birthYearPopup, setBirthYearPopup] = useState();
  const [serializedDobObject, setSerializedDobObject] = useState({});
  const [otpPopUp, setOtpPopUp] = useState(false);
  const [patientId, setPatientId] = useState(true);
  const [reqParams, setReqParams] = useState({});
  const [ocr, setOcr] = useState({
    ocrId: '',
    ocrDate: '',
    isScanned: false,
  });
  const [fileNames, setFileNames] = useState({ front: '', back: '' });
  const [stateCode, setStateCode] = useState('');
  const [number, setNumber] = useState(null);
  const [differentIdPopUp, setDifferentIdPopUp] = useState(false);
  const [code, setCode] = useState('');
  const [display, setDisplay] = useState('');
  const [month, setMonth] = useState(null);
  const [isAlreadyEditPopUpOpen, setIsAlreadyEditPopUpOpen] = useState(false);
  const [countryList, setCountryList] = useState([]);
  const [nationalityList, setNationalityList] = useState([]);
  const [showMobileLink, setShowMobileLink] = useState(false);
  const [errors, setErrors] = useState({});
  const [form, setForm] = useState(defaultFormState);

  const [showHelp, setShowHelp] = useState(false);
  const [showContactSideBar, setShowContactSideBar] = useState(false);
  const [oppositeSide, setOppositeSide] = useState({ shouldUpload: false, side: '' });
  const [isLoading, setIsLoading] = useState(false);
  const isEditFamily = router?.query?.id !== loggedInUserID && !isAdd && !isSidebar;
  const [onChangeEmail, setOnChangeEmail] = useState(false);
  const [disablePrimaryButton, setDisablePrimaryButton] = useState(false);
  const [isPrimaryUser, setIsPrimaryUser]= useState(false);

  const disablePrimaryButtonFromSidebar = (value) => {
    if(isSidebar){
      setDisablePrimaryButtonFromSidebar(value);
    } else {
      setDisablePrimaryButton(value);
    }
  };

  useEffect(() => {
    if (userData && countryList.length && nationalityList.length) {
      const isAddOrSidebar = isAdd || isSidebar;
      const extensions = userData?.extension;
      const extension = extensions?.find((item) => item?.url === 'documentList');
      const isPrimary = extensions?.find((item)=> item?.url === 'isPrimary')?.valueBoolean;
      const idExtension = extension?.extension[0]?.extension?.find((item) => item?.url === 'id');
      const backSideExtension = extension?.extension[0]?.extension?.find((item) => item?.url === 'backSide');
      const frontSideExtension = extension?.extension[0]?.extension?.find((item) => item?.url === 'frontSide');
      const userNumber = userData?.telecom?.find((item) => item.system === 'phone')?.value;
      const periodEndDate = idExtension?.valueIdentifier?.period?.end
        ? new Date(convertDateToISOStandard(idExtension?.valueIdentifier?.period?.end))
        : '';
      const relationShip = userData?.extension?.find((item) => item.url === 'relationShip')?.valueString;
      const getExtensionBooleanValue = (val) =>
        !isAddOrSidebar ? !userData?.extension?.find((item) => item.url === val)?.valueBoolean : true;
      const nameInitials = userData?.extension?.find((item) => item.url === 'nameInitials')?.valueString;
      const indexOfDefaultImg = userData?.photo?.[0]?.url?.indexOf('profile/default.png');
      const nationalityVal = userData?.extension?.find((item) => item.url === 'nationality')?.valueCoding?.display;
      const titleVal = userData?.name?.[0]?.prefix?.[0];
      let visaStatus = '';
      if (extension?.extension[0]?.url === 'emiratesId') {
        visaStatus = 'emiratesID';
      } else if (extension?.extension[0]?.url === 'passport') {
        visaStatus = 'passport';
      } else {
        visaStatus = form.visaStatus;
      }
      setPatientId(userData?.id);
      setIsPrimaryUser(isPrimary);
      setStateCode(userData?.address?.[0]?.state ? userData?.address?.[0]?.state.split('::')[0] : '');
      if (!isAddOrSidebar) {
        setOcr({
          ...ocr,
          ocrId: idExtension?.valueIdentifier?.value,
          ocrDate: periodEndDate,
        });
      }

      let countryData = {};

      if (countryList?.length && !form.country.id) {
        countryData = {
          name: countryList?.[0]?.text || 'Select Country',
          id: countryList?.[0]?.value,
        };
      } else {
        countryData = {
          name: userData?.address?.[0]?.country
            ? userData?.address?.[0]?.country.split('::')[1]
            : getCountryList(countryListSelector)?.[0]?.text || 'Select Country',
          id: userData?.address?.[0]?.country
            ? userData?.address?.[0]?.country.split('::')[0]
            : getCountryList(countryListSelector)?.[0]?.value,
        };
      }

      const profileImg = !nameInitials || indexOfDefaultImg === -1 ? userData?.photo?.[0]?.url : null;

      const isEmiratesId = !isAddOrSidebar && visaStatus === 'emiratesID';
      const isPassport = !isAddOrSidebar && visaStatus === 'passport';
      const dob =
        userData?.birthDate && !isAddOrSidebar ? new Date(convertDateToISOStandard(userData?.birthDate)) : null;

      const newFormData = {
        ...form,
        visaStatus: !isAddOrSidebar ? visaStatus : form.visaStatus,
        emiratesID: {
          ...form.emiratesID,
          val: isEmiratesId ? idExtension?.valueIdentifier?.value : '',
          expiryDate: isEmiratesId ? periodEndDate : null,
        },
        passportNum: {
          ...form.passportNum,
          val: isPassport ? idExtension?.valueIdentifier?.value : '',
          expiryDate: isPassport ? periodEndDate : null,
        },
        name: {
          ...form.name,
          title: !isAddOrSidebar ? titleVal : null,
          firstName: !isAddOrSidebar ? userData?.name?.[0]?.given?.[0] : null,
          lastName: !isAddOrSidebar ? userData?.name?.[0]?.family : null,
          gender: !isAddOrSidebar ? userData?.gender : null,
          relationship: router?.query?.id !== loggedInUserID && !isAddOrSidebar ? relationShip : form.name.relationship,
          isEditable: getExtensionBooleanValue('updateName') || getExtensionBooleanValue('updateTitle'),
        },
        mobile: {
          ...form.mobile,
          number: userNumber?.split('-')?.[1],
          countryCode: userNumber?.split('-')?.[0],
        },
        email: userData?.telecom?.find((item) => item.system === 'email')?.value,
        area: {
          ...form.area,
          name: userData?.address?.[0]?.text ? userData?.address?.[0]?.text : '',
          isEditable: getExtensionBooleanValue('updateArea'),
        },
        base64Images: {
          ...form.base64Images,
          profile: {
            ...form.base64Images.profile,
            img: !isAddOrSidebar ? profileImg : ProfilePlaceholder,
            isDefault: !isAddOrSidebar ? indexOfDefaultImg !== -1 : true,
            isDeletable: true,
          },
          emiratesID: {
            ...form.base64Images.emiratesID,
            frontImg: isEmiratesId ? frontSideExtension?.valueAttachment?.url : null,
            backImg: isEmiratesId ? backSideExtension?.valueAttachment?.url : null,
            isDeletable: getExtensionBooleanValue('updateDocuments'),
          },
          passport: {
            ...form.base64Images.passport,
            frontImg: isPassport ? frontSideExtension?.valueAttachment?.url : null,
            isDeletable: getExtensionBooleanValue('updateDocuments'),
          },
        },
        city: {
          ...form.city,
          name: userData?.address?.[0]?.city ? userData?.address?.[0]?.city.split('::')[1] : 'Select City',
          id: userData?.address?.[0]?.city ? userData?.address?.[0]?.city.split('::')[0] : '',
          isEditable: getExtensionBooleanValue('updateCity'),
        },
        country: countryData,
        nationality: {
          ...form.nationality,
          val: !isAddOrSidebar ? nationalityVal : null,
          isEditable: getExtensionBooleanValue('updateNationality'),
        },
        dob: {
          ...form.dob,
          val: dob,
          isEditable: isEdit ? false : getExtensionBooleanValue('updateDateOfBirth'),
        },
        canEditEIDUploadedImage: getExtensionBooleanValue('updateEid'),
        canEditEIDExpDate: getExtensionBooleanValue('updateEidExpiry'),
      };
      setForm(newFormData);
    }
  }, [userData, countryList, nationalityList]);

  useEffect(() => {
    dispatch(
      getNationalityBlobList({
        onSuccess: (response) => {
          const langCode = getDataFromCookie('langCode');
          const responseArray = Object.values(response);
          setNationalityList(
            responseArray.map((item) => ({
              name: item?.code,
              value: item?.[langCode],
            }))
          );
        },
        onFailure: (err) => {
          errorHandling(err);
        },
      }),
    );

    dispatch(
      getCountryListApi({
        onSuccess: (response) => {
          if (response?.data?.length) {
            setCountryList(getCountryList(response?.data));
          }
        },
        onFailure: (err) => {
          errorHandling(err);
        },
      }),
    );
  }, [userData]);

  useEffect(() => {
    if (parseInt(form.country.id, 10) === 101) {
      dispatch(
        getCityListApi({
          queryParam: { country: form.country.id },
          onSuccess: (response) => {
            setForm({
              ...form,
              city: {
                ...form.city,
                list: getCityList(response?.data),
              },
            });
          },
          onFailure: (err) => {
            errorHandling(err);
          },
        }),
      );
    } else {
      setForm({
        ...form,
        city: {
          ...form.city,
          list: [],
          name: 'Select City',
          id: null,
        },
        area: {
          ...form.area,
          name: '',
        },
      });
    }
  }, [form.country.id]);

  const userProfileComplete = async (response) => {
    const isAddOrSidebar = isAdd || isSidebar;
    const eventName = isAddOrSidebar ? 'Add_Family_Member_Success' : 'complete_profile_success';
    const registrationDate = userLogin?.extension?.find((x) => x?.url === 'patientRegistrationDate')?.valueString;
    const profileData = {
      sign_up_date: registrationDate,
      sign_in_date: formatDate(new Date()),
      profile_completion_date: formatDate(new Date()),
    };
    if (isAddOrSidebar) {
      dataLayerAddFamilyMemberSuccess(
        doctorName ? doctorName : getScreenNameForAddFamily(router?.pathname),
        getPageTypeForAddFamily(router?.pathname),
        getMyAsterCategory(router?.pathname),
        router?.query?.referrerPage ? `${router?.query?.referrerPage} page` : '',
        docID,
      );
    } else {
      dataLayerSendEvent(eventName, profileData);
      sendEventData({
        event: EVENT_NAMES.COMPLETE_PROFILE_SUCCESS,
        pageType: PAGE_TYPE.PROFILE,
        category: MY_ASTER_CATEGORY.ASCO,
        referrerPage: referralPageForGa,
        screenName: SCREEN_NAME.COMPLETE_PROFILE,
      });
      sendAdjustEvent(ADJUST_EVENT_TOKENS.PROFILE_COMPLETION);
    }
    sendEventToSmartLook(eventName, isAddOrSidebar ? eventName : 'complete profile success');
    if (isSidebar) {
      onSuccess(response);
    } else {
      toast.success(isAddOrSidebar ? 'Family Member Added!!' : 'You have successfully completed your profile!!');
    }
  };

  const checkUserApiCall = (cb) => {
    dispatch(
      checkUserExist({
        params: {
          mobile: encodeURIComponent(authCtx?.idTokenParsed?.mobile_number),
          id: authCtx?.idTokenParsed?.sub,
        },
        onSuccess: () => {cb()},
        onFailure: (err) => {
          errorHandling(err);
          cb();
        },
      }),
    );
  };

  const handleCompleteSuccess = (response, isNumberNotAccessible, isFromDobPopup) => {
    if (response?.extension?.find((x) => x?.url === 'isPrimary')?.valueBoolean) {
      localStorage.setItem('PreselectedPatientId', response?.id);
    }
    const eventParameters = {
      screen_name: doctorName ? docName : 'add family members',
      page_type: doctorName ? PAGE_TYPE.DDP : PAGE_TYPE.PROFILE,
      myaster_category: doctorName ? MY_ASTER_CATEGORY?.DOCTOR_CONSULT : MY_ASTER_CATEGORY?.ASCO,
    };

    if (docID && doctorName && doctorName !== 'asco homepage') {
      eventParameters.page_id = docID;
    }

    if (response.status === 201) {
      userProfileComplete(response);
      checkUserApiCall(() => {
        if (!isSidebar) {
          if (isNumberNotAccessible) {
            setThankYouScreen(true);
          } else if (router?.query?.path && isCompleteProfileSecondary) {
            if (sessionStorage.getItem('bookAppointmentLogin')) {
              sessionStorage.removeItem('bookAppointmentLogin');
            }
            if (sessionStorage.getItem('bookAppointmentCompleteProfile')) {
              sessionStorage.removeItem('bookAppointmentCompleteProfile');
            }
            if (sessionStorage.getItem('instantGpCompleteProfile')) {
              sessionStorage.setItem('instantGpCompleteProfile', 'true');
            }
            if (sessionStorage.getItem('rxUploadCompleteProfile')) {
              sessionStorage.setItem('rxUploadCompleteProfile', 'true');
            }
            if (sessionStorage.getItem('isFromRxUpload')) {
              sessionStorage.setItem('isFromRxUpload', 'true');
            }
            if (sessionStorage.getItem('bookAppointmentUpdateNow')) {
              sessionStorage.removeItem('bookAppointmentUpdateNow');
            }
            
            const path = JSON.parse(router?.query?.path);
            const queryParams = path.query;
            if (path?.pathname === '/doctor-consultation/quickbooking/list') queryParams.isProfileCompleted = true;
            router.push({
              pathname: generateURL(path?.pathname),
              query: queryParams,
            });
            sessionStorage.setItem('UpdateNowSuccessMsg', true);
            if (path?.pathname === '/doctor-consultation/checkout') queryParams.isProfileCompleted = true;
            router.push({
              pathname: generateURL(path?.pathname),
              query: queryParams,
            });
            if (path?.pathname === '/doctor-consultation/instantgp/checkout') queryParams.isProfileCompleted = true;
            router.push({
              pathname: generateURL(path?.pathname),
              query: queryParams,
            });
          }
          else if (router?.query?.redirectPath) {
            const path = JSON.parse(router?.query?.redirectPath);
            const queryParams = path.query;
            if (path?.pathname === '/doctor-consultation/records') {
              queryParams.currentSelectedUser = response?.id;
              router.push({
                pathname: generateURL(decodeURIComponent(path?.pathName)),
                query: typeof queryParams === 'string' ? decodeURIComponent(queryParams) : queryParams,
              });
            } else {
              queryParams.id = response?.id;
              router.push({
                pathname: generateURL(decodeURIComponent(path?.pathName)),
                query: typeof queryParams === 'string' ? decodeURIComponent(queryParams) : queryParams,
              });
            }
          } else {
            if (isFromDobPopup) {
              toast.success('DOB updated successfully!');
            }
            const path = router?.query?.path || '/profile/myprofile';
            if (path.includes('rxupload')) {
              const queryParams = extractQueryString(path);
              router.push({
                pathname: generateURL('/online-pharmacy/rxupload'),
                query: queryParams,
              });
            } else {
              router.push({ pathname: generateURL(decodeURIComponent(path)) });
            }
          }
        }
      });
    } else {
      setErrorModal(true);
    }
  };

  const handleEditSuccess = (res, params, isFromDobPopup) => {
    const supportTicketCreated = res?.extension?.find((item) => item.url === 'supportTicketCreated')
      ? res?.extension?.find((item) => item.url === 'supportTicketCreated')?.valueBoolean
      : false;
      if(isPrimaryUser){
        dataLayerProfileUpdateSuccess('edit profile', PAGE_TYPE?.PROFILE, referralPageForGa);
      }else {
        dataLayerFamilyMembersEdit('edit profile', PAGE_TYPE?.PROFILE, referralPageForGa);
      }
    dataLayerProfileManagementSuccess('Edit_Profile_Success', 'Edit Profile Screen');
    if (router?.query?.path && isCompleteProfileSecondary) {
      if (sessionStorage.getItem('bookAppointmentLogin')) {
        sessionStorage.removeItem('bookAppointmentLogin');
      }
      if (sessionStorage.getItem('bookAppointmentCompleteProfile')) {
        sessionStorage.removeItem('bookAppointmentCompleteProfile');
      }
      if (sessionStorage.getItem('instantGpCompleteProfile')) {
        sessionStorage.setItem('instantGpCompleteProfile', 'true');
      }
      if (sessionStorage.getItem('isFromRxUpload')) {
        sessionStorage.setItem('isFromRxUpload', 'true');
      }
      if (sessionStorage.getItem('bookAppointmentUpdateNow')) {
        sessionStorage.removeItem('bookAppointmentUpdateNow');
      }

      const path = JSON.parse(router?.query?.path);
      const queryParams = path.query;
      if (path?.pathname === '/doctor-consultation/quickbooking/list')
        queryParams.isProfileCompleted = !res?.extension?.find((item) => item?.url === 'isIdExpired')?.valueBoolean;
      router.push({
        pathname: generateURL(path?.pathname),
        query: queryParams,
      });
      sessionStorage.setItem('UpdateNowSuccessMsg', true);
      if (path?.pathname === '/doctor-consultation/checkout')
        queryParams.isProfileCompleted = !res?.extension?.find((item) => item?.url === 'isIdExpired')?.valueBoolean;
      router.push({
        pathname: generateURL(path?.pathname),
        query: queryParams,
      });
      if (path?.pathname === '/doctor-consultation/instantgp/checkout')
        queryParams.isProfileCompleted = !res?.extension?.find((item) => item?.url === 'isIdExpired')?.valueBoolean;
      router.push({
        pathname: generateURL(path?.pathname),
        query: queryParams,
      });
    } else if (supportTicketCreated) {
      setSuccessModal(true);
      setEidMessage(res?.extension?.find((item) => item.url === 'supportTicketGeneratedMessage')?.valueString);
    } else {
      if (isFromDobPopup) {
        toast.success('DOB updated successfully!');
      } else {
        toast.success('Profile details updated successfully!');
      }
      if (loggedInUserID === params?.id) {
        router.push({
          pathname: generateURL('/profile/myprofile'),
          query: {
            successToast: true,
            editEid: router?.query?.editEid,
          },
        });
      } else if (router?.query?.edit === 'edit') {
        router.push({
          pathname: generateURL('/profile/managefamilymembers/[memberId]'),
          query: {
            memberId: userData?.id,
            successToast: true,
            editEid: router?.query?.editEid,
          },
        });
      } else {
        router.push({
          pathname: generateURL('/profile/managefamilymembers'),
          query: {
            successToast: true,
          },
        });
      }
    }
  };

  const handleFailure = (error) => {
    const issue = error?.data?.issue?.[0];
    const errorCode = error?.errorCode;
    const isWithDifferentNo = issue?.details?.coding?.some((x) => x.code === 'PATIENT_WITH_DIFFERENT_MOBILE_NUMBER');
    const isDifferentDobFound = issue?.details?.coding?.some((x) => x.code === 'Mismatch Found in Date of Birth');
    const isTitle = issue?.details?.coding?.find((x) => x.code)?.code;
    const isBody = issue?.details?.coding?.find((x) => x.display)?.display;
    const firstText = isBody?.split('/')?.[0];
    const secondText = isBody?.split('/')?.[1];
    const differentID = issue?.details.coding.find((x) => x.code === 'Different Emirates ID Found');
    const isPatientUnderReview = issue?.details?.coding?.find((x) => x?.code === 'PATIENT_UNDER_REVIEW OR REJECTED');
    const isAlreadyLinked = issue?.details?.coding?.find((x) => x?.code === 'FAMILY_MEMBER_ALREADY_LINKED');
    const isAddOrSidebar = isAdd || isSidebar;
    setDisablePrimaryButton(false);
    disablePrimaryButtonFromSidebar(false);
    if (isPrimaryUser) {
      dataLayerEditProfileError(
        'edit profile',
        PAGE_TYPE?.PROFILE,
        referralPageForGa,
        'something went wrong',
        ERROR_TYPE.API_ERROR,
      );
    } else {
      dataLayerAddFamilyMemberError(
        doctorName ? doctorName : getScreenNameForAddFamily(router?.pathname),
        getPageTypeForAddFamily(router?.pathname),
        getMyAsterCategory(router?.pathname),
        router?.query?.referrerPage ? `${router?.query?.referrerPage} page` : referralPageForGa,
        issue?.diagnostics || 'something went wrong',
        ERROR_TYPE.API_ERROR,
        docID,
      );
    }
    if (errorCode === 400) {
      if (differentID && isEdit) {
        setDifferentIdPopUp(true);
        setCode(differentID?.code);
        setDisplay(differentID?.display);
      } else if (isWithDifferentNo) {
        const age = getAge(form.dob.val);
        if (age >= 18 || isEdit) {
          setOtpPopUp(true);
          setShowMobileLink(true);
          setNumber(issue?.diagnostics);
        } else {
          reqParams.telecom.push({
            system: 'other',
            value: issue[0].diagnostics,
          });
          reqParams.extension.push({
            url: 'alternateMobileVerficationStatus',
            valueString: true,
          });

          if (isAddOrSidebar) {
            // eslint-disable-next-line no-use-before-define
            onSubmitClick(reqParams);
          }
        }
      } else if (isAlreadyLinked && isAddOrSidebar) {
        toast.error('Family Member with same uid is already linked with account');
      } else if (isDifferentDobFound) {
        setSerializedDobObject({ isTitle, firstText, secondText });
        setBirthYearPopup(true);
      } else if (error?.data?.issue?.[0]?.diagnostics === 'Email already exists.' && isEdit) {
        toast.error(error?.data?.issue?.[0]?.diagnostics);
      } else if (isPatientUnderReview && isEdit) {
        toast.error(error?.data?.issue?.[0]?.diagnostics);
      } else if (!isEdit) {
        setErrorModal(true);
        toast.error(isAddOrSidebar ? 'Something went wrong!!' : issue?.diagnostics);
      } else {
        toast.error('Something went wrong!!');
      }
    } else if (!isEdit) {
      setErrorModal(true);
      toast.error(isAddOrSidebar ? 'Something went wrong!!' : issue?.diagnostics);
    } else {
      toast.error('Something went wrong!!');
    }
  };

  const onSubmitClick = (params, isNumberNotAccessible, isFromDobPopup) => {
    setDisablePrimaryButton(true);
    disablePrimaryButtonFromSidebar(true);
    const bookAppointmentUpdateNow = sessionStorage.getItem('bookAppointmentUpdateNow');
    if (!isEdit && !bookAppointmentUpdateNow) {
      dispatch(
        completeProfile({
          params: isCompleteProfileSecondary ? { ...params, id: router?.query?.id } : params,
          onSuccess: (response) => handleCompleteSuccess(response, isNumberNotAccessible, isFromDobPopup),
          onFailure: (error) => handleFailure(error),
        }),
      );
    } else {
      setLoadingEdit(true);
      dispatch(
        editProfile({
          params: isCompleteProfileSecondary ? { ...params, id: router?.query?.id } : params,
          onSuccess: (response) => {
            handleEditSuccess(response, params, isFromDobPopup);
            setLoadingEdit(false);
          },
          onFailure: (error) => {
            handleFailure(error);
            setLoadingEdit(false);
          },
        }),
      );
    }
  };

  const expiryDateValue = () => {
    if (form.visaStatus === 'emiratesID') {
      return form.emiratesID.expiryDate ? new Date(convertDateToISOStandard(form.emiratesID.expiryDate)) : '';
    }
    return form.passportNum.expiryDate ? new Date(convertDateToISOStandard(form.passportNum.expiryDate)) : '';
  };

  const onEmiratesIdFieldChange = (e) => {
    const isEmiratesId = form.visaStatus === 'emiratesID';
    setOcr({
      ...ocr,
      isScanned: false,
    });
    if (isEmiratesId) {
      setForm({
        ...form,
        emiratesID: {
          ...form.emiratesID,
          val: formatEmiratesId(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '')) || '',
        },
      });
    } else {
      setForm({
        ...form,
        passportNum: {
          ...form.passportNum,
          val: e.target.value.toUpperCase() || '',
        },
      });
    }

    const newErrors = { ...errors };

    const idLabel = 'emiratesID';
    const passportNumLabel = 'passportNum';
    const passportNumError = 'Please enter passport number';
    const idError1 = 'Please enter emirates Id';
    const idError2 = 'First three digits should be 784';
    const idError3 = 'Invalid EID number';
    const idError4 = 'Age must be over 18 years';
    const idError5 = 'Please enter complete emirates Id ';

    const inputVal = isEmiratesId
      ? formatEmiratesId(e.target.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, ''))
      : e.target.value.toUpperCase();

    if (isEmiratesId) {
      if (!inputVal || inputVal === '') {
        newErrors[idLabel] = idError1;
      } else if (inputVal.substring(0, 3) !== '784') {
        newErrors[idLabel] = idError2;
      } else if (Number(inputVal.substring(4, 8)) > Number(getCurrentYear())) {
        newErrors[idLabel] = idError3;
      } else if (Number(inputVal.substring(4, 8)) > Number(getCurrentYear() - 18) && !isNotCompleteProfileScreen) {
        newErrors[idLabel] = idError4;
      } else if (inputVal.length < 18) {
        newErrors[idLabel] = idError5;
      } else {
        newErrors[idLabel] = null;
        if (Number(inputVal.substring(4, 8)) === new Date(form.dob.val)?.getFullYear()) {
          newErrors.birthYear = null;
        }
      }
    }

    if (!isEmiratesId) {
      if (!inputVal || inputVal === '') {
        newErrors[passportNumLabel] = passportNumError;
      } else if (!PASSPORT_FORMAT.test(inputVal) || inputVal.length < 7) {
        newErrors[passportNumLabel] = 'Passport number is invalid';
      } else {
        newErrors[passportNumLabel] = null;
      }
    }

    setErrors(newErrors);
  };

  const isEmiratesIdDisabled = () => {
    let value = true;
    if (
      form.visaStatus === 'emiratesID' &&
      (form.base64Images.emiratesID.frontImg || form.base64Images.emiratesID.backImg)
    ) {
      value = false;
    } else if (form.visaStatus === 'passport' && form.base64Images.passport.frontImg) {
      value = false;
    }
    return value;
  };

  const isExpDateDisabled = () => {
    let value = true;
    if (
      form.visaStatus === 'emiratesID' &&
      (form.base64Images.emiratesID.frontImg || form.base64Images.emiratesID.backImg)
    ) {
      value = false;
    } else if (form.visaStatus === 'passport' && form.base64Images.passport.frontImg) {
      value = false;
    }
    return value;
  };

  const onCalendarChange = (value) => {
    const isEmiratesId = form.visaStatus === 'emiratesID';

    const expiryVal = convertDateToBackendServer(value);
    if (isEmiratesId) {
      setForm({
        ...form,
        emiratesID: {
          ...form.emiratesID,
          expiryDate: expiryVal,
        },
      });
    } else {
      setForm({
        ...form,
        passportNum: {
          ...form.passportNum,
          expiryDate: expiryVal,
        },
      });
    }

    const expiryDateLabel = isEmiratesId ? 'emiratesExpDate' : 'passportExpDate';
    const expiryDateError = isEmiratesId ? 'Your emirates Id is expired' : 'Your passport is expired';

    if (expiryVal && !isFutureDate(value)) {
      setErrors({ ...errors, [expiryDateLabel]: expiryDateError });
    } else {
      setErrors({ ...errors, [expiryDateLabel]: null });
    }
  };

  const getEmailExistsOrNot = (emailId) =>
    new Promise((res, rej) => {
      dispatch(
        checkEmailExist({
          params: {
            email: emailId,
          },
          onSuccess: (response) => {
            if (
              !response?.data?.isEmailExist ||
              emailId === userData?.telecom?.find((item) => item.system === 'email')?.value
            ) {
              if (!errors?.email || errors?.email === 'Email address already exists') {
                setErrors({ ...errors, email: null });
                setEmailExistError(false);
              } else if (emailId === null || emailId === '') {
                setErrors({ ...errors, email: 'Please enter email' });
              } else {
                setErrors({ ...errors });
              }
            } else if (response?.data?.isEmailExist && emailId !== null && emailId !== '') {
              setEmailExistError(true);
              setErrors({ ...errors, email: response?.message });
            }
            res(response);
          },
          onFailure: (err) => {
            errorHandling(err);
            rej(err);
          },
        }),
      );
    });

  const findFormErrors = async () => {
    const newErrors = {};

    const isEmiratesId = form.visaStatus === 'emiratesID';
    const isPassport = form.visaStatus === 'passport';

    if (!form.name.gender || form.name.gender === '') newErrors.title = 'Please select gender';
    if ((!form.name.firstName || form.name.firstName === '') && form.name.isEditable)
      newErrors.firstName = 'Please enter first name';

    if (!form.name.lastName || form.name.lastName === '') newErrors.lastName = 'Please enter last name';

    if (!form.country.name || form.country.name === 'Select Country') {
      newErrors.country = 'Please select country';
    }

    if (!form.email || form.email === '') {
      newErrors.email = 'Please enter Email';
    } else if (form.email) {
      const emailError = await getEmailExistsOrNot(form?.email);
      const {
        data: { isEmailExist },
        message,
      } = emailError || {};
      if (onChangeEmail && isEmailExist) {
        newErrors.email = message;
      } else if (!isEmailExist && validateEmail(form?.email) && form?.email !== '' && form?.email !== null) {
        newErrors.email = null;
      }
    }

    if ((!form.city.name || form.city.name === 'Select City') && parseInt(form.country.id, 10) === 101) {
      newErrors.city = 'Please select city';
    }

    if (!form.dob.val) {
      newErrors.birthDate = 'Please enter date of birth';
    }

    if (
      form.emiratesID.val &&
      form.dob.val &&
      (form?.dob?.ocrDob
        ? new Date(form.dob?.val)?.getFullYear() !== new Date(form?.dob?.ocrDob)?.getFullYear()
        : Number(form.emiratesID.val.substring(4, 8)) !== new Date(form.dob?.val)?.getFullYear()) &&
      isNotCompleteProfileScreen &&
      form.visaStatus === 'emiratesID'
    ) {
      newErrors.birthYear = 'Year of birth doesn’t match EID details';
    }

    if (!form.name.relationship || form.name.relationship === 'Select Relationship') {
      newErrors.relation = 'Please select relationship';
    }

    if (!form.nationality.val) {
      newErrors.nationality = 'Please select nationality';
    }

    if (!form.terms) {
      newErrors.terms = 'Please accept terms and conditions';
    }

    const expiryDate = isEmiratesId ? form.emiratesID.expiryDate : form.passportNum.expiryDate;
    const expiryDateLabel = isEmiratesId ? 'emiratesExpDate' : 'passportExpDate';

    if ((!expiryDate || expiryDate === '') && form.canEditEIDExpDate) {
      newErrors[expiryDateLabel] = 'Please enter expiry date';
    }

    const frontImage = isEmiratesId ? form.base64Images.emiratesID.frontImg : form.base64Images.passport.frontImg;
    const frontImageLabel = isEmiratesId ? 'base64FrontImg' : 'base64forFrontPassport';
    const frontImageError = isEmiratesId ? 'Please select front side of Emirates id' : 'Please select passport image';

    if (!frontImage || frontImage === '') {
      newErrors[frontImageLabel] = frontImageError;
    }

    const backImageLabel = 'base64BackImg';
    const backImageError = 'Please select back side of Emirates id';

    if (isEmiratesId && (!form.base64Images.emiratesID.backImg || form.base64Images.emiratesID.backImg === '')) {
      newErrors[backImageLabel] = backImageError;
    }

    const idLabel = 'emiratesID';
    const idError1 = 'Please enter emirates Id';
    const idError2 = 'First three digits should be 784';

    if (isEmiratesId) {
      if (!form.emiratesID.val || form.emiratesID.val === '') {
        newErrors[idLabel] = idError1;
      }

      if (form?.emiratesID?.val?.substring(0, 3) !== '784') {
        newErrors[idLabel] = idError2;
      }

      if (
        form?.dob?.ocrDob &&
        Number(form.emiratesID.val.substring(4, 8)) !== new Date(form?.dob?.ocrDob)?.getFullYear()
      ) {
        newErrors[idLabel] = 'Year of birth doesn’t match EID details';
      }
    }

    const passportNumLabel = 'passportNum';
    const passportNumError = 'Please enter passport number';

    if (isPassport && (!form.passportNum.val || form.passportNum.val === '')) {
      newErrors[passportNumLabel] = passportNumError;
    }

    if (
      isPassport &&
      form.passportNum.val &&
      !PASSPORT_FORMAT.test(form.passportNum.val) &&
      form.passportNum.val.length < 7
    ) {
      newErrors[passportNumLabel] = 'Passport number is invalid';
    }

    const areaNameLabel = 'areaName';
    const areaNameError = 'Please enter area name';

    if ((!form?.area.name || form?.area.name === '') && parseInt(form.country.id, 10) === 101) {
      newErrors[areaNameLabel] = areaNameError;
    }

    const filteredErrorsByType = filterErrorObjectBasedOnType(
      {
        ...errors,
        ...newErrors,
      },
      type,
      isFromErxOrInstantGp,
    );
    const filteredErrorObjectWithOnlyValues = Object.keys(filteredErrorsByType).reduce((acc, key) => {
      if (filteredErrorsByType[key]) {
        acc[key] = filteredErrorsByType[key];
      }
      return acc;
    }, {});

    setErrors(filteredErrorObjectWithOnlyValues);

    return filteredErrorObjectWithOnlyValues;
  };

  const handleSubmit = async (e = null, flag = false, isFromDobPopup = false) => {
    e?.preventDefault();
    const getOCRStatus = () => {
      const expData = ocr?.ocrDate !== '' ? ocr?.ocrDate?.getTime() : ocr?.ocrDate;
      if (form.visaStatus === 'emiratesID') {
        return (
          form.emiratesID?.expiryDate &&
          ocr?.ocrId === form.emiratesID?.val &&
          expData === new Date(convertDateToISOStandard(form.emiratesID?.expiryDate))?.getTime() &&
          ocr?.isScanned
        );
      }
      return (
        form?.passportNum?.expiryDate &&
        ocr?.ocrId === form?.passportNum?.val &&
        expData === new Date(convertDateToISOStandard(form?.passportNum?.expiryDate))?.getTime() &&
        ocr?.isScanned
      );
    };

    const params = getReqParams(
      form,
      mobileWithCode,
      getOCRStatus,
      type,
      fileNames?.front,
      fileNames?.back,
      flag,
      stateCode,
      patientId,
      isEditFamily,
      isNotCompleteProfileScreen,
    );

    const newErrors = await findFormErrors();
    if (Object.keys(newErrors).length > 0) {
      Object.keys(newErrors).map((key) =>{
        if (!isAdd && !isSidebar && isEdit) {
          dataLayerEditProfileError(
            'edit profile',
            PAGE_TYPE?.PROFILE,
            referralPageForGa,
            newErrors[key],
            ERROR_TYPE.VALIDATION_ERROR,
          );
        } else {
          if (!isAdd && !isSidebar) {
            dataLayerProfileManagementFailure(
              'Complete_Profile_Error',
              'Complete Profile Screen',
              newErrors[key],
              doctorName,
              docID,
              docName,
            );
          } else {
            dataLayerAddFamilyMemberError(
              doctorName ? doctorName : getScreenNameForAddFamily(router?.pathname),
              getPageTypeForAddFamily(router?.pathname),
              getMyAsterCategory(router?.pathname),
              router?.query?.referrerPage ? `${router?.query?.referrerPage} page` : referralPageForGa,
              newErrors[key],
              ERROR_TYPE.VALIDATION_ERROR,
              docID,
            );
          }
        }
      }
      );

      if (isAdd || isSidebar) {
        sendEventToSmartLook('Add_Family_Member_Error', 'Add_Family_Member_Error');
      }

      const getFirstErrorName = (val) => {
        if (val === 'title') {
          return 'gender';
        }

        if (val === 'birthYear') {
          return 'birthDate';
        }

        return val;
      };

      const firstError = filterFormElementsArrBasedOnType(type, isFromErxOrInstantGp).find((key) => newErrors[key]);
      if (firstError) {
        const element = document.querySelector(`[name=${getFirstErrorName(firstError)}]`);
        if (element) {
          element.scrollIntoView({
            behavior: 'smooth',
            block: 'start',
            inline: 'nearest',
          });
          element.focus();
        }
      }
    } else {
      onSubmitClick(params, false, isFromDobPopup);
    }
    setReqParams(params);
  };

  useEffect(() => {
    if (sidebarSubmitClicked) {
      handleSubmit();
    }
  }, [sidebarSubmitClicked]);

  const getIDForCity = (arrList, val) => {
    const value = arrList?.find((item) => item?.text === val);
    setForm({
      ...form,
      city: {
        ...form.city,
        id: value?.value,
        name: val,
      },
    });
    setStateCode(value?.stateCode);
  };

  const getIDForCountry = (arrList, vlue) => {
    const value = arrList?.find((item) => item?.text === vlue);
    return value?.value;
  };

  const primaryButtonClicked = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    setModal(false);
  };

  const getEmiratesBase64 = (rawbase64, side, imgSide, key) => {
    setIsLoading(true);
    dispatch(
      readEmiratesID({
        params: { base64: rawbase64?.split(',')?.[1] },
        onSuccess: (response) => {
          formatEmiratesResponse(
            response,
            side,
            setOcr,
            setErrors,
            imgSide === 'front' ? rawbase64 : form.base64Images.emiratesID.frontImg,
            imgSide === 'back' ? rawbase64 : form.base64Images.emiratesID.backImg,
            setForm,
            errors,
            setModal,
            eventText,
            form,
            ocr,
            imgSide,
            key,
            isNotCompleteProfileScreen,
          );
          if (form?.visaStatus === 'emiratesID') {
            setOppositeSide({ shouldUpload: true, side });
          } else {
            setIsLoading(false);
          }
        },
        onFailure: (e) => {
          setandShowModalProps(false, setModal, form.visaStatus, eventText);
          setIsLoading(false);
          errorHandling(e);
        },
      }),
    );
  };

  const fetchOppSideOCRDetails = async (rawbase64, side, imgSide, key) => {
    dispatch(
      readEmiratesID({
        params: { base64: rawbase64?.split(',')?.[1] },
        onSuccess: (response) => {
          formatEmiratesResponse(
            response,
            side,
            setOcr,
            setErrors,
            form.base64Images.emiratesID.frontImg,
            form.base64Images.emiratesID.backImg,
            setForm,
            errors,
            setModal,
            eventText,
            form,
            ocr,
            imgSide,
            key,
            isNotCompleteProfileScreen,
          );
          setIsLoading(false);
          setOppositeSide({ shouldUpload: false });
        },
        onFailure: (e) => {
          setandShowModalProps(false, setModal, form.visaStatus, eventText);
          setIsLoading(false);
          setOppositeSide({ shouldUpload: false });
          errorHandling(e);
        },
      }),
    );
  };

  useEffect(() => {
    try {
      const imageToBase64 = async (image) => {
        if (image?.startsWith('http')) {
          const base64 = await fetch(image)
            .then((res) => res.blob())
            .then((blob) => {
              const reader = new FileReader();
              reader.readAsDataURL(blob);
              return new Promise((res) => {
                reader.onloadend = () => {
                  res(reader.result);
                };
              });
            });
          return base64;
        }
        return image;
      };

      const handleSideProcessing = async (side) => {
        const sideLowerCase = side.toLowerCase();
        const imageData = form?.base64Images?.emiratesID?.[`${sideLowerCase}Img`];
        if (imageData) {
          const processedImage = await imageToBase64(imageData);
          fetchOppSideOCRDetails(processedImage, side, sideLowerCase, sideLowerCase);
        } else {
          setIsLoading(false);
          setOppositeSide({ shouldUpload: false });
        }
      };

      if (oppositeSide?.shouldUpload) {
        const side = oppositeSide?.side === 'Front' ? 'Back' : 'Front';
        handleSideProcessing(side);
      }
    } catch (e) {
      errorHandling(e);
    }
  }, [oppositeSide?.shouldUpload]);

  const getBase64Image = (file, side) => {
    const reader = new FileReader();
    const updateForm = (key, value) => {
      setForm((prevForm) => ({
        ...prevForm,
        [key]: value,
      }));
    };

    const updateBase64Image = (key, imgSide, readerResult) => {
      setForm((prevForm) => ({
        ...prevForm,
        base64Images: {
          ...prevForm.base64Images,
          [key]: {
            ...prevForm.base64Images[key],
            [`${imgSide}Img`]: readerResult,
          },
        },
      }));
      getEmiratesBase64(readerResult, side, imgSide, key);
      setFileNames((prevFileNames) => ({
        ...prevFileNames,
        [imgSide.toLowerCase()]: file.name,
      }));
    };
    reader.readAsDataURL(file);
    reader.onload = () => {
      if (side !== 'Profile') {
        updateBase64Image(
          form.visaStatus === 'emiratesID' ? 'emiratesID' : 'passport',
          side.toLowerCase(),
          reader.result,
        );
      } else {
        updateForm('base64Images', {
          ...form.base64Images,
          profile: {
            ...form.base64Images.profile,
            img: reader.result,
            isChanged: true,
          },
        });
      }
    };
  };

  const changeHandlerProfileImg = (event) => {
    const fileData = event?.target?.files[0];
    const isValidSize = isImageSizeValid(event);
    if (!(fileData?.name?.includes('jpeg') || fileData?.name?.includes('png') || fileData?.name?.includes('jpg'))) {
      setErrors({ ...errors, profileImg: 'Invalid document format. Please use JPG, JPEG or PNG.' });
    } else if (!isValidSize) {
      setErrors({ ...errors, profileImg: 'size should be less than 5Mb' });
    } else {
      getBase64Image(event?.target?.files?.[0], 'Profile');
      setErrors({ ...errors, profileImg: null });
    }
  };

  const onCountrySelect = (val) => {
    setForm({
      ...form,
      country: {
        ...form.country,
        name: val,
        id: getIDForCountry(countryList, val),
      },
    });

    setErrors({ ...errors, country: null });
  };

  const onCityChange = (e) => {
    getIDForCity(form.city.list, e.target.value);
    if (!e.target.value && parseInt(form.country.id, 10) === 101) {
      setErrors({ ...errors, city: 'Please select city' });
    } else setErrors({ ...errors, city: null });
  };

  const handleImageChange = (event, imgType) => {
    const fileData = event?.target?.files[0];
    const isValidSize = isImageSizeValid(event);
    const fileType = imgType === 'FrontPassport' ? 'Passport' : 'Emirates ID';
    const stateKey = imgType === 'FrontPassport' ? 'base64forFrontPassport' : `base64${imgType}Img`;

    if (
      !(
        fileData?.name?.toLowerCase().includes('jpeg') ||
        fileData?.name?.toLowerCase().includes('png') ||
        fileData?.name?.toLowerCase().includes('jpg')
      )
    ) {
      setErrors({ ...errors, [stateKey]: 'Invalid document format. Please use JPG, JPEG or PNG.' });
    } else if (!isValidSize) {
      setErrors({ ...errors, [stateKey]: 'size should be less than 5Mb' });
    } else {
      const side = imgType === 'Front' || imgType === 'FrontPassport' ? 'Front' : 'Back';
      setForm((prevForm) => ({
        ...prevForm,
        dob: {
          ...prevForm.dob,
          isEditable: true,
        },
      }));
      getBase64Image(fileData, side);
      setErrors({ ...errors, [stateKey]: null });
    }
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
  };

  const changeHandlerFrontImg = (event) => {
    handleImageChange(event, 'Front');
  };

  const changeHandlerBackImg = (event) => {
    handleImageChange(event, 'Back');
  };

  const changeHandlerFrontPassport = (event) => {
    handleImageChange(event, 'FrontPassport');
  };

  const handleAreaNameChange = (e) => {
    setForm({
      ...form,
      area: {
        ...form.area,
        name: e.target.value,
      },
    });

    const areaNameLabel = 'areaName';
    const areaNameError = 'Please enter area name';

    if ((!form?.area.name || form?.area.name === '' || !e.target.value) && parseInt(form.country.id, 10) === 101) {
      setErrors({ ...errors, [areaNameLabel]: areaNameError });
    } else setErrors({ ...errors, [areaNameLabel]: null });
  };

  const renderDocumentFields = () => {
    if (form.visaStatus === 'emiratesID') {
      return (
        <Row>
          <Row className="uploadIdLabel">
            <Col md={6} sm={6} xs={12}>
              <Form.Label className="mb-2">Upload Emirates ID</Form.Label>
            </Col>
            {!isSidebar ? (
              <Col md={isCompleteProfileSecondary ? 12 : 6} sm={6} xs={12} className="img-sub-title">
                <div className="mb-2">File Format: JPG, JPEG &amp; PNG | File Size: 5MB Max</div>
              </Col>
            ) : null}
          </Row>
          <Col md={6} sm={6} xs={12} className="mb-4" id="OrderedCustomerName" data-sl="mask">
            <fieldset className={!isCompleteProfile ? 'mobile-id-pic' : ''}>
              <SquareImageUpload
                textTitle="Front Side"
                textSubTitle={!isSidebar ? 'Drag and Drop here' : null}
                linkSubTitle={!isSidebar ? ' Browse files' : null}
                label={!isSidebar ? 'Upload Emirates ID' : null}
                src={form.base64Images.emiratesID.frontImg}
                name="base64FrontImg"
                deleteImg={() => {
                  setForm({
                    ...form,
                    base64Images: {
                      ...form.base64Images,
                      emiratesID: {
                        ...form.base64Images.emiratesID,
                        frontImg: null,
                      },
                    },
                    emiratesID: {
                      ...form?.emiratesID,
                      val: '',
                      expiryDate: null,
                    },
                    dob: {
                      ...form?.dob,
                      ocrDob: null,
                    },
                  });

                  if (ocr?.frontHasExpDate) {
                    setErrors({
                      ...errors,
                      emiratesExpDate: null,
                    });
                  }
                  setOcr({
                    ...ocr,
                    ocrId: '',
                    isScanned: false,
                  });
                }}
                changeHandler={changeHandlerFrontImg}
                isInvalid={!!errors.base64FrontImg}
                errorMessage={errors.base64FrontImg}
              />
              {isSidebar ? <div className="img-sub-title mb-3">File Format: JPG, JPEG &amp; PNG</div> : null}
            </fieldset>
          </Col>
          <Col md={6} sm={6} xs={12} className="mb-4" id="OrderedCustomerName" data-sl="mask">
            <Form.Group>
              <fieldset className={!isCompleteProfile ? 'mobile-id-pic' : ''}>
                <SquareImageUpload
                  textTitle="Back Side"
                  textSubTitle={!isSidebar ? 'Drag and Drop here' : null}
                  linkSubTitle={!isSidebar ? ' Browse files' : null}
                  name="base64BackImg"
                  src={form.base64Images.emiratesID.backImg}
                  deleteImg={() => {
                    setForm({
                      ...form,
                      base64Images: {
                        ...form.base64Images,
                        emiratesID: {
                          ...form.base64Images.emiratesID,
                          backImg: null,
                        },
                      },
                    });

                    if (ocr?.backHasExpDate) {
                      setErrors({
                        ...errors,
                        emiratesExpDate: null,
                      });
                    }

                    setOcr({
                      ...ocr,
                      isScanned: false,
                    });
                  }}
                  changeHandler={changeHandlerBackImg}
                  isInvalid={!!errors.base64BackImg}
                  errorMessage={errors.base64BackImg}
                />
                {isSidebar ? <div className="img-sub-title mb-3">File Size: 5MB Max</div> : null}
              </fieldset>
            </Form.Group>
          </Col>
        </Row>
      );
    }

    return (
      <Row>
        <Form.Label className="mb-2">Upload Passport ID</Form.Label>
        <div className="img-sub-title mb-2">File Format: JPG, JPEG &amp; PNG | File Size: 5MB Max</div>
        <Col md={6} className="mb-4">
          <fieldset disabled={isCompleteProfile ? false : !form.base64Images.passport.isDeletable}>
            <SquareImageUpload
              textTitle="Passport Page"
              textSubTitle={!isSidebar ? 'Drag and Drop here' : null}
              linkSubTitle={!isSidebar ? ' Browse files' : null}
              label="Upload Passport"
              name="base64forFrontPassport"
              src={form.base64Images.passport.frontImg}
              deleteImg={() =>
                setForm({
                  ...form,
                  base64Images: {
                    ...form.base64Images,
                    passport: {
                      ...form.base64Images.passport,
                      frontImg: null,
                    },
                  },
                  passportNum: {
                    val: '',
                    expiryDate: null,
                  },
                  dob: {
                    ...form?.dob,
                    ocrDob: null,
                  },
                })
              }
              changeHandler={changeHandlerFrontPassport}
              isInvalid={!!errors.base64forFrontPassport}
              errorMessage={errors.base64forFrontPassport}
            />
            {isSidebar ? (
              <div className="img-sub-title mb-3">File Format: JPG, JPEG &amp; PNG | File Size: 5MB Max</div>
            ) : null}
          </fieldset>
        </Col>
        <Col md={6} className="mb-4" />
      </Row>
    );
  };

  const deleteProfileImg = () =>
    setForm({
      ...form,
      base64Images: {
        ...form.base64Images,
        profile: {
          ...form.base64Images.profile,
          img: null,
          isChanged: true,
        },
      },
    });

  const onNameChange = (e, key) => {
    const name = e?.target?.value?.replace(/[^a-zA-Z, ]/, '')?.trim();
    setForm({
      ...form,
      name: {
        ...form.name,
        [key]: name,
      },
    });
    if (name.length > 30) {
      setErrors({ ...errors, [key]: '30 characters limit exceeded' });
    } else if (name.length <= 1) {
      setErrors({
        ...errors,
        [key]: `Please enter valid ${key === 'firstName' ? 'first' : 'last'} name`,
      });
    } else if (NAME_FORMAT.test(name)) {
      setErrors({ ...errors, [key]: 'Name cannot contain special characters' });
    } else {
      setErrors({ ...errors, [key]: null });
    }
  };

  useEffect(() => {
    if (userData?.length) {
      const alreadyEditPopupOpen =
        !form.name.isEditable ||
        !form.nationality.isEditable ||
        !form.dob.isEditable ||
        !form.canEditEIDExpDate ||
        !form.canEditEIDUploadedImage ||
        !form.city.isEditable ||
        !form.area.isEditable ||
        !form.base64Images.passport.isDeletable;
      setIsAlreadyEditPopUpOpen(alreadyEditPopupOpen);
    }
  }, [userData]);

  const navigateToSourceRoute = () => {
    if (router?.query?.redirectPath) {
      const path = JSON.parse(router?.query?.redirectPath);
      const queryParams = path.query;
      router.push({
        pathname: generateURL(path?.pathName),
        query: queryParams,
      });

      return;
    }

    if (isCompleteProfile) {
      const path = router?.query?.path || '/profile/myprofile';
      router.push({ pathname: generateURL(path) });
      return;
    }

    if (isAdd) {
      router.push({
        pathname: generateURL('/profile/managefamilymembers'),
      });
      return;
    }

    if (isEdit) {
      if (loggedInUserID === router?.query?.id) {
        router.push({
          pathname: generateURL('/profile/myprofile'),
          query: {
            editEid: router?.query?.editEid,
          },
        });
      } else if (router?.query?.edit === 'edit') {
        router.push({
          pathname: generateURL('/profile/managefamilymembers/[memberId]'),
          query: {
            memberId: userData?.id,
            editEid: router?.query?.editEid,
          },
        });
      } else {
        router.push({
          pathname: generateURL('/profile/managefamilymembers'),
        });
      }
    }
  };

  const messageForOCRModal = 'We kindly request you to verify/complete your ID details before submitting.';

  const renderForm = () => (
    <>
      <Loader isLoading={isLoading} />
      <Form>
        {!isCompleteProfileSecondary && !isCompleteProfileOther ? (
          <div className={`box ${!isCompleteProfile && !isAdd ? 'mobile-profile-pic mt-4' : 'mb-4'}`}>
            <ProfileImageUpload
              customClass={isEdit ? 'mobile-profile-pic-icon mb-4' : ''}
              profilePicData={form.base64Images.profile.img}
              changeHandler={changeHandlerProfileImg}
              isInvalid={!!errors.profileImg}
              errorMessage={errors.profileImg}
              userData={userData}
              isDeleteEnable={isCompleteProfile ? false : form.base64Images.profile.isDeletable}
              isDefaultImage={isCompleteProfile ? false : form.base64Images.profile.isDefault}
              deleteImg={isCompleteProfile ? null : deleteProfileImg}
              name="base64ProfileImg"
            />
          </div>
        ) : null}
        <div className="box mb-4">
          {isNotCompleteProfileScreen ? (
            <>
              <Row>
                <Col md={isSidebar ? 12 : 6} className="mb-4">
                  <fieldset disabled={!form.name.isEditable}>
                    <InputFieldControl
                      isLabel
                      label="First Name"
                      textType="text"
                      data-test="firstName"
                      placeholder="Enter First Name"
                      onChange={(e) => onNameChange(e, 'firstName')}
                      valueType={form.name.firstName}
                      isInvalid={!!errors.firstName}
                      errorMessage={errors.firstName}
                      name="firstName"
                    />
                  </fieldset>
                </Col>
                <Col md={isSidebar ? 12 : 6} className="mb-4">
                  <fieldset disabled={!form.name.isEditable}>
                    <InputFieldControl
                      isLabel
                      label="Last Name"
                      textType="text"
                      data-test="lastName"
                      placeholder="Enter Last Name"
                      onChange={(e) => onNameChange(e, 'lastName')}
                      name="lastName"
                      valueType={form.name.lastName}
                      isInvalid={!!errors.lastName}
                      errorMessage={errors.lastName}
                    />
                  </fieldset>
                </Col>
              </Row>
              <Row className="dropdown-wrapper genderRow">
                <Col md={isSidebar ? 12 : 6} className="mb-4">
                  <SelectTablets
                    label="Gender"
                    name="gender"
                    activeVal={form.name.gender}
                    firstLabelImage={IC_MALE}
                    secondLabelImage={IC_FEMALE}
                    firstLabelImageBlue={IC_MALE_BLUE}
                    secondLabelImageBlue={IC_FEMALE_BLUE}
                    firstVal="Male"
                    secondVal="Female"
                    error={errors.title}
                    onClick={(val) => {
                      setForm({
                        ...form,
                        name: {
                          ...form.name,
                          gender: val,
                        },
                      });
                      if (
                        val &&
                        form.name.relationship === 'Select Relationship' &&
                        router?.query?.id !== loggedInUserID
                      )
                        setErrors({ ...errors, title: null, relation: null });
                      else if (
                        relationshipData.find((x) => x?.text === form.name.relationship)?.gender !== val &&
                        router?.query?.id !== loggedInUserID
                      )
                        setErrors({ ...errors, title: 'Please select valid gender' });
                      else setErrors({ ...errors, title: null, relation: null });
                    }}
                  />
                </Col>
                <Col md={isSidebar ? 12 : 6} className="mb-4">
                  <fieldset disabled={!form.dob.isEditable}>
                    <div className="date-picker-input">
                      <DateOfBirth
                        disabled={!form.dob.isEditable}
                        pageName={isEdit ? 'Edit Profile' : 'AddNewFamilyMember'}
                        getBirthDate={(e) => {
                          setForm({
                            ...form,
                            dob: {
                              ...form.dob,
                              val: convertDateToBackendServer(e),
                            },
                          });
                          const val = convertDateToBackendServer(e);
                          const monthVal = months[new Date(val)?.getMonth()] || month;
                          if (val === INVALID_DATE || val === null || monthVal === null) {
                            setErrors({ ...errors, birthDate: 'Please enter valid date of birth' });
                          } else if (
                            form.emiratesID.val &&
                            (form?.dob?.ocrDob
                              ? new Date(val)?.getFullYear() !== new Date(form?.dob?.ocrDob)?.getFullYear()
                              : Number(form.emiratesID.val.substring(4, 8)) !== new Date(val)?.getFullYear()) &&
                            isNotCompleteProfileScreen &&
                            form.visaStatus === 'emiratesID'
                          ) {
                            setErrors({ ...errors, birthYear: 'Year of birth doesn’t match EID details' });
                          } else {
                            setErrors({ ...errors, birthDate: null, birthYear: null });
                          }
                        }}
                        name="birthDate"
                        getMonthOfDate={(e) => {
                          setMonth(e);
                        }}
                        errorMessage={errors.birthDate}
                        yobMismatchError={errors.birthYear}
                        birthDate={form.dob.val ? new Date(convertDateToISOStandard(form.dob.val)) : null}
                      />
                    </div>
                  </fieldset>
                </Col>
              </Row>
              <Row className={`${errors?.relation ? 'dropdown-wrapper errorAlignedRow' : 'dropdown-wrapper'}`}>
                {router?.query?.id === loggedInUserID && !isAdd ? (
                  <Col md={6} className="mb-4">
                    <fieldset disabled>
                      <MobileInputFieldControl
                        label="Mobile Number"
                        extValue={form.mobile.countryCode}
                        valueType={form.mobile.number}
                        readOnly={false}
                        textType="string"
                        placeholder="Mobile Number"
                        handleSelect={(e) => {
                          setForm({ ...form, mobile: { ...form.mobile, countryCode: e } });
                        }}
                      />
                    </fieldset>
                  </Col>
                ) : (
                  <Col md={isSidebar ? 12 : 6} className="mb-4" id="mask-data" data-sl="mask">
                    <SelectControl
                      enableFullWidth
                      data={relationshipData}
                      caption={
                        form.name.relationship === 'Select Relationship' ? 'Relationship' : form.name.relationship
                      }
                      data-test="relation"
                      label={form.name.relationship === 'Select Relationship' ? '' : 'Relationship'}
                      onChange={(e) => {
                        const relation = e.target.value;
                        setForm({
                          ...form,
                          name: {
                            ...form.name,
                            relationship: relation,
                          },
                        });
                        if (
                          form.name.gender &&
                          relationshipData.find((x) => x?.text === relation)?.gender !== form.name.gender &&
                          router?.query?.id !== loggedInUserID
                        ) {
                          setErrors({ ...errors, title: 'Please select valid gender' });
                        } else setErrors({ ...errors, relation: null, title: null });
                      }}
                      isInvalid={!!errors.relation}
                      errorMessage={errors.relation}
                      name="relation"
                      customClass={form.name.relationship === 'Select Relationship' ? 'select-placeholder' : ''}
                    />
                  </Col>
                )}
                <Col md={isSidebar ? 12 : 6} className="mb-4 emailNumCol">
                  {router?.query?.id === loggedInUserID && !isAdd ? (
                    <InputFieldControl
                      isLabel
                      label="Email Address"
                      textType="text"
                      placeholder="Email Address"
                      data-test="email"
                      onChange={(e) => {
                        const val = e.target.value;
                        setForm({ ...form, email: val });
                        setOnChangeEmail(true);
                        if (!validateEmail(val)) {
                          setErrors({ ...errors, email: 'Email is not valid' });
                        } else if (emailExistError) {
                          setErrors({ ...errors, email: 'Email address already exists' });
                        } else if (val === '' || val === null) {
                          setErrors({ ...errors, email: 'Please enter email' });
                        } else {
                          setErrors({ ...errors, email: null });
                        }
                      }}
                      onBlur={async (e) => {
                        await getEmailExistsOrNot(e.target.value);
                      }}
                      name="email"
                      valueType={form.email}
                      isInvalid={!!errors.email}
                      errorMessage={errors.email}
                    />
                  ) : (
                    <fieldset disabled>
                      <MobileInputFieldControl
                        label="Mobile Number"
                        extValue={form.mobile.countryCode}
                        valueType={form.mobile.number}
                        readOnly={false}
                        textType="string"
                        placeholder="Mobile Number"
                        handleSelect={(e) => {
                          setForm({ ...form, mobile: { ...form.mobile, countryCode: e } });
                        }}
                      />
                    </fieldset>
                  )}
                </Col>
              </Row>
              <Row>
                <Col md={isSidebar ? 12 : 6} className="mb-4">
                  <div className="nationalityWrapper">
                    <fieldset disabled={!form.nationality.isEditable}>
                      <SearchDropDown
                        valueType={form.nationality.val}
                        placeholder="Nationality"
                        options={nationalityList}
                        name="nationality"
                        onChange={(value) => {
                          setForm({
                            ...form,
                            nationality: {
                              ...form.nationality,
                              val: nationalityList?.find((item) => item?.value === value)?.name,
                            },
                          });
                          setErrors({
                            ...errors,
                            nationality: null,
                          });
                        }}
                        isInvalid={!!errors.nationality}
                        errorMessage={errors.nationality}
                      />
                    </fieldset>
                  </div>
                </Col>
              </Row>
            </>
          ) : null}
          <Row>
            <Col
              md={isSidebar ? 12 : isCompleteProfileSecondary ? 8 : 6}
              className={`mb-4
              ${!isNotCompleteProfileScreen ? 'mt-4' : ''}
            `}
            >
              <SelectTablets
                label="Visa Status"
                name="status"
                activeVal={form.visaStatus === 'emiratesID' ? 'resident' : 'tourist'}
                firstVal="Resident"
                secondVal="Tourist"
                onClick={(val) => {
                  if (val === 'resident') {
                    setForm({
                      ...form,
                      emiratesID: {
                        val: form.emiratesID.val || '',
                        expiryDate: form.emiratesID.expiryDate || '',
                      },
                      visaStatus: 'emiratesID',
                    });
                    setErrors({
                      ...errors,
                      passportNum: null,
                      base64forFrontPassport: null,
                      passportExpDate: null,
                    });
                  } else {
                    setForm({
                      ...form,
                      passportNum: {
                        val: form.passportNum.val || '',
                        expiryDate: form.passportNum.expiryDate || '',
                      },
                      visaStatus: 'passport',
                    });
                    setErrors({
                      ...errors,
                      base64BackImg: null,
                      emiratesID: null,
                      base64FrontImg: null,
                      emiratesExpDate: null,
                      birthYear: null,
                    });
                  }
                }}
              />
            </Col>
          </Row>
          {isSidebar ? (
            <AddNewFamilyMemberStyled>{renderDocumentFields()}</AddNewFamilyMemberStyled>
          ) : (
            renderDocumentFields()
          )}
          <Row>
            <Col md={isSidebar || isCompleteProfileSecondary ? 12 : 6} className="mb-4">
              <fieldset disabled={!isCompleteProfile ? !form.canEditEIDUploadedImage : false}>
                <InputFieldControl
                  label={form.visaStatus === 'emiratesID' ? 'Emirates ID' : 'Passport ID'}
                  textType="text"
                  placeholder={form.visaStatus === 'emiratesID' ? 'Emirates ID' : 'Passport ID'}
                  data-test="emiratesID"
                  onChange={onEmiratesIdFieldChange}
                  name={form.visaStatus === 'emiratesID' ? 'emiratesID' : 'passportNum'}
                  maxLength={form.visaStatus === 'emiratesID' ? 18 : 9}
                  minLength={form.visaStatus === 'emiratesID' ? 18 : 7}
                  valueType={form.visaStatus === 'emiratesID' ? form.emiratesID.val : form.passportNum.val}
                  isInvalid={form.visaStatus === 'emiratesID' ? !!errors.emiratesID : !!errors.passportNum}
                  errorMessage={form.visaStatus === 'emiratesID' ? errors.emiratesID : errors.passportNum}
                  isLabel
                  disabled={isEmiratesIdDisabled()}
                />
              </fieldset>
            </Col>
          </Row>
          <Row>
            <Col md={isSidebar || isCompleteProfileSecondary ? 12 : 6} className="mb-4 expiryDate">
              <div className="date-picker-input">
                <ExpiryDate
                  labelText="Expiry Date"
                  errorMessage={form.visaStatus === 'emiratesID' ? errors.emiratesExpDate : errors.passportExpDate}
                  name={form.visaStatus === 'emiratesID' ? 'emiratesExpDate' : 'passportExpDate'}
                  expiryDate={expiryDateValue()}
                  getExpiryDate={onCalendarChange}
                  disabled={(!isCompleteProfile ? !form.canEditEIDExpDate : false) || isExpDateDisabled()}
                />
              </div>
            </Col>
          </Row>
          {!isSidebar && isFromErxOrInstantGp && !isCompleteProfileOther ? (
            <>
              <Row>
                <Col md={6} className="mb-4" id="mask-data" data-sl="mask">
                  <DropdownControl
                    theme="countryDropdown"
                    enableFullWidth
                    data={countryList}
                    caption={form.country.name}
                    data-test="country"
                    name="country"
                    label="Country"
                    handleSelect={onCountrySelect}
                    isInvalid={!!errors.country}
                    errorMessage={errors.country}
                  />
                </Col>
                {parseInt(form.country.id, 10) === 101 && (
                  <Col md={6} className="mb-4" id="mask-data" data-sl="mask">
                    <fieldset disabled={!isCompleteProfile ? !form.city.isEditable : false}>
                      <SelectControl
                        enableFullWidth
                        data={form.city.list}
                        caption={form.city.name}
                        data-test="city"
                        name="city"
                        label="City"
                        onChange={onCityChange}
                        isInvalid={!!errors.city}
                        errorMessage={errors.city}
                      />
                    </fieldset>
                  </Col>
                )}
              </Row>
              {parseInt(form.country.id, 10) === 101 && (
                <Row>
                  <Col md={6} className="mb-4">
                    <fieldset disabled={!isCompleteProfile ? !form.area.isEditable : false}>
                      <InputFieldControl
                        label="Area"
                        textType="text"
                        placeholder="Enter Area Name"
                        readOnly={false}
                        data-test="area"
                        onChange={handleAreaNameChange}
                        name="areaName"
                        valueType={form.area.name}
                        isInvalid={!!errors.areaName}
                        errorMessage={errors.areaName}
                        isLabel
                      />
                    </fieldset>
                  </Col>
                </Row>
              )}
            </>
          ) : null}
          {isAdd || isSidebar ? (
            <Row className="dropdown-wrapper">
              <Col md={11} className="mb-4">
                {isSidebar ? (
                  <div className="consentText">
                    I hereby declare that I am lawfully authorised and have permission to access all profile details,
                    records and all reports on behalf of the owner of the information.
                  </div>
                ) : (
                  <CheckboxControl
                    label="I hereby declare that I am lawfully authorized and 
                      have permission to access all profile details, records and all reports on behalf
                       of the owner of the information."
                    checked={form.terms}
                    data-test="terms"
                    onClick={() => {
                      setForm({
                        ...form,
                        terms: !form.terms,
                      });
                      setErrors({ ...errors, terms: null });
                    }}
                    isInvalid={!!errors.terms}
                    errorMessage={errors.terms}
                  />
                )}
              </Col>
            </Row>
          ) : null}
          {!isSidebar ? (
            <Row>
              <Col md={isCompleteProfileSecondary ? 5 : 4} className="mb-4">
                <ButtonBase
                  data-test="submitButton"
                  minWidth="240px"
                  text={label}
                  variant="primary"
                  size="md"
                  type="submit"
                  onClick={handleSubmit}
                  disabled={disablePrimaryButton}
                />
              </Col>
            </Row>
          ) : null}
        </div>
      </Form>
      {modal ? (
        <CustomModal
          bodyTextCenter
          footerBtnFullWidth={false}
          size="md"
          footerAlignment="center"
          primaryButtonText="Ok"
          primaryButtonClicked={primaryButtonClicked}
        >
          <p className="mb-0">{messageForOCRModal}</p>
        </CustomModal>
      ) : null}
      {birthYearPopup ? (
        <CustomModal
          bodyTextCenter
          footerBtnFullWidth
          modalTitle={serializedDobObject?.isTitle}
          size="md"
          customClass="missMatchModal"
          outerCustomClass="missMatchModalOuter"
          footerAlignment="center"
          primaryButtonText="Confirm"
          secondaryButtonText="Cancel"
          seconderyButtonClcked={() => {
            setBirthYearPopup(false);
          }}
          primaryButtonClicked={() => {
            setBirthYearPopup(false);
            handleSubmit(null, true, true);
          }}
        >
          <p className={`${isNotCompleteProfileScreen ? 'mb-3 customWidth' : 'mb-3'}`}>
            {!isNotCompleteProfileScreen
              ? serializedDobObject?.firstText
              : serializedDobObject?.firstText?.replace(' during registration', '')}
          </p>
          <p className="my-0">{serializedDobObject?.secondText}</p>
        </CustomModal>
      ) : null}
      {isAlreadyEditPopUpOpen && isEdit && (
        <CustomModal
          bodyTextCenter
          footerBtnFullWidth={false}
          size="md"
          footerAlignment="center"
          primaryButtonText="Ok"
          primaryButtonClicked={primaryButtonClicked}
        >
          <p className="mb-0">Your requested edits is under progress</p>
        </CustomModal>
      )}
      {differentIdPopUp && isEdit && (
        <CustomModal
          modalTitle={code}
          bodyTextCenter
          footerBtnFullWidth={false}
          size="md"
          footerAlignment="center  pt-0"
          secondaryButtonText="Cancel"
          customClass="create-profile-modal "
          seconderyButtonClcked={() => setDifferentIdPopUp(false)}
        >
          <div className="mb-0">
            <div>{display}</div>
            <div className="edit-profile-modal-text-wrapper">
              <div className="image-wrapper">
                <div>
                  <Image src={IC_PHONE_GREY} width="40" height="40" alt="" />
                </div>
                <div className="img-text-wrapper">+971-800-700-600</div>
              </div>
              <span
                data-test="id"
                className="contact cursor-pointer"
                onClick={() => {
                  if (userLogin) setIsLoggedInUser(true);
                  setDifferentIdPopUp(false);
                }}
              >
                <div className=" image-wrapper">
                  <div>
                    <Image src={IC_CHAT_BLUE} width="40" height="40" alt="" />
                  </div>
                  <div className="img-text-wrapper">Contact us</div>
                </div>
              </span>
            </div>
          </div>
        </CustomModal>
      )}
      {otpPopUp ? (
        <OtpModal
          visaStatus={form.visaStatus}
          otpPopUp={otpPopUp}
          patientId={patientId}
          setOtpPopUp={setOtpPopUp}
          reqParams={reqParams}
          onSubmitClick={onSubmitClick}
          number={number}
          type={type}
          mobileWithCode={mobileWithCode}
          setShowMobileLink={setShowMobileLink}
          showMobileLink={showMobileLink}
        />
      ) : null}
      {showHelp && isCompleteProfileOther && (
        <HelpPopUp
          close={() => {
            setShowHelp(false);
          }}
          setShowContactSideBar={setShowContactSideBar}
        />
      )}
      {showContactSideBar && isCompleteProfileOther && (
        <ContactFormSidebar
          wrapperClassName="contact cursor-pointer"
          showLabel={false}
          setShowContactSideBar={setShowContactSideBar}
        />
      )}
    </>
  );

  return isCompleteProfileSecondary ? (
    renderForm()
  ) : (
    <BlankCard
      title={title}
      border
      customClass={!isCompleteProfile ? 'blank-card-overflow-unset blank-card-main mb-5' : ''}
      arrowimage
      onClick={navigateToSourceRoute}
      imgBox={isCompleteProfileOther}
      imgSrc={isCompleteProfileOther ? IC_QUESTION : null}
      blueText={isCompleteProfileOther ? 'Help' : null}
      handleBlueTextClick={() => setShowHelp(true)}
    >
      {renderForm()}
    </BlankCard>
  );
};

AutoScrollForm.propTypes = {
  title: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  userData: PropTypes.object.isRequired,
  setThankYouScreen: PropTypes.func.isRequired,
  setErrorModal: PropTypes.func,
  type: PropTypes.string.isRequired,
  setSuccessModal: PropTypes.func.isRequired,
  setEidMessage: PropTypes.func.isRequired,
  setIsLoggedInUser: PropTypes.func.isRequired,
  sidebarSubmitClicked: PropTypes.string.isRequired,
  eventText: PropTypes.string.isRequired,
  onSuccess: PropTypes.func.isRequired,
  isFromErxOrInstantGp: PropTypes.bool,
  docName: PropTypes.string.isRequired,
  setLoadingEdit: PropTypes.func,
  setDisablePrimaryButtonFromSidebar: PropTypes.func,
};

AutoScrollForm.defaultProps = {
  setErrorModal: () => {},
  isFromErxOrInstantGp: true,
  setLoadingEdit: () => {},
};

export default AutoScrollForm;
